import React from "react";

import { ReleasePersonListContainer } from "./ReleasePersonListContainer";
import ReleaseTeamListContainer from "./ReleaseTeamListContainer";
import ListWrapper from "../../../common/management/ListWrapper";

type Props = {
  clearSearch: () => void;
  currentPage: number;
  perView: number;
};

const SelectReleaseList: React.FC<Props> = ({
  clearSearch,
  currentPage,
  perView,
}) => {
  return (
    <main style={{ width: "100%" }}>
      {/* TODO add company */}
      <ListWrapper
        pageTitle={"公開申請一覧"}
        tabs={["プロフィール", "チーム"]}
        clearHandler={clearSearch}
      >
        <ReleasePersonListContainer
          currentPage={currentPage}
          perView={perView}
        />
        <ReleaseTeamListContainer
          currentPage={currentPage}
          perView={perView}
          isSelect={true}
        />
      </ListWrapper>
    </main>
  );
};

export default SelectReleaseList;
